import {
  getNotFromSimpleFilter,
  getOperatorFromQueryFilter,
  getOperatorFromSimpleFilter,
} from '@/sections/insights/queryBuilder/entities/common/translators';
import type {
  SimpleFilter,
  SimpleFilterDefinition,
} from '@/sections/insights/queryBuilder/entities/types';
import type { QueryFilter } from '@/types';

/**
 * AD Object ObjectID field definition
 * Free-text input (no preset values)
 */
export const ADObjectObjectID: SimpleFilterDefinition = {
  apiField: 'objectid',
  uiField: 'ObjectID',
  inputType: 'text', // Text input, no dropdown
  operators: [
    'is',
    'is not',
    'contains',
    'does not contain',
    'starts with',
    'ends with',
  ],

  translateForUI: (queryFilter: QueryFilter): SimpleFilter => {
    return {
      field: 'ObjectID',
      operator: getOperatorFromQueryFilter(queryFilter),
      value: queryFilter.value as string | string[],
    };
  },

  translateForAPI: (simpleFilter: SimpleFilter): QueryFilter => {
    return {
      field: 'objectid',
      operator: getOperatorFromSimpleFilter(simpleFilter),
      value: simpleFilter.value,
      not: getNotFromSimpleFilter(simpleFilter),
    };
  },
};
